var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { LogMeasurementType, PLAN_TYPE, ProductPlanResponseStatus, } from '@logz-pkg/enums';
import { Expose } from 'class-transformer';
export class PlanInfoModel {
    type;
    logMeasurementType;
    billingCycle;
    paymentMethod;
    taxPercentage;
    totalPrice;
    products;
    billingType;
    subscriptionStatus;
    lastActiveDate;
    isGrouped;
    isCommunityAccount() {
        return [PLAN_TYPE.FREE, PLAN_TYPE.TRIAL].includes(this.type);
    }
    isPayingAccount() {
        return [PLAN_TYPE.PRO, PLAN_TYPE.ENTERPRISE].includes(this.type);
    }
    isTrial() {
        return [PLAN_TYPE.TRIAL].includes(this.type);
    }
    hasErrorsInProductPlans() {
        return this.products.some(plan => plan.responseStatus !== ProductPlanResponseStatus.SUCCESS);
    }
    isIngested() {
        return this.logMeasurementType === LogMeasurementType.Ingested;
    }
}
__decorate([
    Expose({ name: 'isGroup' }),
    __metadata("design:type", Boolean)
], PlanInfoModel.prototype, "isGrouped", void 0);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Boolean)
], PlanInfoModel.prototype, "isCommunityAccount", null);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Boolean)
], PlanInfoModel.prototype, "isPayingAccount", null);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Boolean)
], PlanInfoModel.prototype, "isTrial", null);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Boolean)
], PlanInfoModel.prototype, "hasErrorsInProductPlans", null);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Boolean)
], PlanInfoModel.prototype, "isIngested", null);
//# sourceMappingURL=plan-info.js.map